module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarXD-4.7af95e04.png";